import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PeerConnection from '../../modules/server/PeerConnection';
import { MEMBER_STATUS, getBridgeSession, getDisplayNickname, getMemberByUserID } from '../base/members';
import { Icon } from '../base/ui';
export const DualMemeber = React.memo(({ id }) => {
    const videoRef = useRef(null);
    const nicknameRef = useRef(null);
    const member = useSelector((state) => getMemberByUserID(state, id));
    const memberVideoMuted = useSelector((state) => getBridgeSession(state, id)?.video_muted);
    const [track, setTrack] = useState(null);
    const [peer, setPeer] = useState(null);
    const [muted, setMuted] = useState(false);
    const [lefted, setLefted] = useState(false);
    const handler = {
        addTrack: (streams, videoTrack) => {
            if (videoRef.current && streams) {
                videoRef.current.srcObject = streams;
                videoRef.current.autoplay = true;
            }
            setTrack(streams);
        },
        isMuted: (muted) => {
            setMuted(muted);
        },
    };
    useEffect(() => {
        setMuted(memberVideoMuted);
    }, [memberVideoMuted]);
    useEffect(() => {
        if (member?.status === MEMBER_STATUS.VACATED) {
            setLefted(true);
            setTrack(null);
        }
        else {
            setLefted(false);
        }
    }, [member?.status]);
    useEffect(() => {
        if (member?.user_uuid && member.status === MEMBER_STATUS.OCCUPIDE) {
            const pc = new PeerConnection(member.user_uuid, member.member_uuid, false, handler);
            pc.initLocalStream(null, null);
            APP.peerconnections.push(pc);
            setPeer(pc);
        }
        else {
            setPeer(null);
        }
    }, [member?.user_uuid, member?.status]);
    useEffect(() => {
        return () => {
            if (peer) {
                peer?.disconnect();
                APP.peerconnections = APP.peerconnections.filter(p => p?.user_id !== member?.user_uuid);
            }
        };
    }, [peer]);
    const handlerDesciption = data => {
        const from_member_id = data.from;
        if (from_member_id === member?.member_uuid) {
            if (peer) {
                peer.setRemoteDescription(data.answer);
            }
        }
    };
    const handlerCandinate = data => {
        const from_member_id = data.from;
        if (from_member_id === member?.member_uuid) {
            if (peer) {
                peer.addIceCandidate(data.ice_candidate);
            }
        }
    };
    useEffect(() => {
        APP.eventManager.subscribe('CALL_ANSWER', handlerDesciption);
        APP.eventManager.subscribe('CALL_CANDIDATE', handlerCandinate);
        return () => {
            APP.eventManager.unsubscribe('CALL_ANSWER', handlerDesciption);
            APP.eventManager.unsubscribe('CALL_CANDIDATE', handlerCandinate);
        };
    }, [peer, member?.member_uuid]);
    return (React.createElement("div", { className: "dual-item" },
        React.createElement("div", { className: `frame-987255 ${track && !muted ? 'video_show' : 'video_hide'}` },
            React.createElement("div", { className: 'video-wrap', style: { display: `${track && !muted ? 'block' : 'none'}` } },
                React.createElement("video", { key: member?.user_uuid, ref: videoRef, muted: true, autoPlay: true, playsInline: true })),
            React.createElement("div", { className: "icon-off-camera" }, lefted ? React.createElement(Icon, { icon: "icon-not-user", size: 65 })
                : track ?
                    muted ? React.createElement(Icon, { icon: "icon-off-camera", size: 65 }) : null
                    : React.createElement(Icon, { icon: "icon-not-camera", size: 65 })),
            React.createElement("div", { className: 'nickname_wrap' },
                React.createElement("p", { ref: nicknameRef, className: "nickname overText2" }, getDisplayNickname(member?.nickname, member?.role)))),
        React.createElement("div", { className: "_1" },
            React.createElement(Icon, { icon: lefted ? "disconnect" : "connect", size: 32 }))));
});
